import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import * as SetMarketingStatusActionMetadataKeys from 'automation-ui-action-features/deprecated/set-marketing-status/SetMarketingStatusActionMetadataKeys';
import { MARKETABLE_UNTIL_RENEWAL } from 'automation-ui-action-features/deprecated/set-marketing-status/marketingTypeConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
const SetMarketingStatusActionDetail = ({
  actionMetadata
}) => {
  const marketableType = actionMetadata.get(SetMarketingStatusActionMetadataKeys.MARKETABLE_TYPE);
  return marketableType === MARKETABLE_UNTIL_RENEWAL ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "automation-ui-action-features.action-features.set-marketing-status.action-detail.content.MARKETABLE_UNTIL_RENEWAL_jsx",
    options: {
      supportKey: SupportLinkKeys.SET_CONTACT_AS_MARKETING
    },
    elements: {
      DocButton
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.set-marketing-status.action-detail.content.MARKETABLE"
  });
};
export default SetMarketingStatusActionDetail;